/**
 * API path constants aligned with backend routes (src/features/.../routes.ts).
 * Use these so frontend and backend stay in sync.
 */
export const API_PATHS = {
  // Auth (src/features/auth/routes.ts)
  AUTH_LOGIN: "/api/v1/auth/login",
  ACCOUNTS_TOKEN: "/api/v1/accounts/token/",

  // Health (src/features/health/routes.ts)
  HEALTH: "/health",

  // Export (src/features/export/routes.ts)
  EXPORT_DECL: "/api/v1/ezyplus/export-decl/",
  EXPORT_ENTRIES: "/api/v1/export-entries",
  EXPORT_ENTRIES_BY_ID: (id: string) => `/api/v1/export-entries/${id}`,
  VALIDATE_DECL: "/api/v1/ezyplus/validate-decl/",
  CALCULATE: "/api/v1/calculate/",
  PRINT_DOCUMENT: "/api/v1/export/print-document/",
  SEND_EXPORT_DECL: "/api/v1/export/send-export-decl/",
  EXPORT_ENTRIES_SUBMIT: (id: string) => `/api/v1/export-entries/${id}/submit`,

  // GCL (src/features/gcl/routes.ts)
  GCL_ENTRIES: "/api/v1/gcl-entries",
  GCL_CREATE_UPDATE: "/api/v1/goodcontrol/create-update-gcl/",

  // Short (src/features/short/routes.ts)
  SHORT_ENTRIES: "/api/v1/short-entries",
  SHORT_CREATE_UPDATE: "/api/v1/short/create-update-short/",

  // Cancel (src/features/cancel/routes.ts)
  CANCEL_DOCUMENT: "/api/v1/cancel/cancel-document/",

  // XML (src/features/xml/routes.ts)
  GET_XML: "/api/v1/getxml",

  // Webhooks – TIFFA (src/features/webhook/routes.ts). Spec path: /api/v1/webhooks/tiffa/update-status
  WEBHOOKS_SEND_MOCK: "/api/v1/tiffa/webhooks/send-mock",
  WEBHOOKS_RECEIVED: "/api/v1/tiffa/webhooks/received",
  WEBHOOKS_TIFFA_UPDATE: "/api/v1/webhooks/tiffa/update-status",
  TIFFA_WEBHOOKS: "/api/v1/tiffa/webhooks",
  TIFFA_WEBHOOK_RETRY: (id: string) => `/api/v1/tiffa/webhooks/${id}/retry`,

  // Liner (src/features/liner/routes.ts)
  DCSA_BOOKING: "/api/dcsa-booking",
  LINER_WEBHOOKS_DEFAULTS: "/api/v1/liner/webhooks/defaults",
  LINER_WEBHOOKS_SEND_MOCK: "/api/v1/liner/webhooks/send-mock",

  // Simulation config (src/features/config/routes.ts)
  SIMULATION_CONFIG: "/api/v1/simulation-config",
} as const;
